import React, { memo } from 'react';
import CircularLoader from '../CircularLoader/CircularLoader';
import styles from './loadingView.module.scss';

export default memo(function LoadingView(props) {
    return (
        <>
            <div className={styles.container}>
                <CircularLoader size={48} />
            </div>
            {props.background && <img alt={props.alt} className={styles.blurredBackground} src={props.background} />}
        </>
    );
});
